export default "__VITE_ASSET__F37unZel__"